import posthog from 'posthog-js'

let initialized = false
let enabled = false

export function initPostHog(): boolean {
  if (initialized) return enabled

  const analyticsEnabled = import.meta.env.VITE_ANALYTICS_ENABLED === 'true'
  if (!analyticsEnabled) {
    initialized = true
    return false
  }

  const posthogKey = import.meta.env.VITE_POSTHOG_KEY
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'

  if (!posthogKey) {
    console.warn('PostHog disabled: missing VITE_POSTHOG_KEY')
    initialized = true
    return false
  }

  try {
    posthog.init(posthogKey, {
      api_host: posthogHost,

      autocapture: false,
      capture_pageview: false,
      disable_session_recording: true,

      person_profiles: 'identified_only',
    })
    
    // Register platform as a super property (applies to all events)
    const platform = import.meta.env.VITE_PLATFORM || 'web'
    posthog.register({
      platform,
      app_name: platform === 'android' ? 'Goldrush Android' : platform === 'ios' ? 'Goldrush iOS' : 'Goldrush Web',
      $os: platform === 'android' ? 'Android' : platform === 'ios' ? 'iOS' : 'Web',
      $device_type: platform !== 'web' ? 'Mobile' : 'Desktop',
    })
    
    enabled = true
  } catch (err) {
    console.warn('PostHog init failed, analytics disabled', err)
  }

  initialized = true
  return enabled
}

export function isPostHogEnabled(): boolean {
  return enabled
}

export { posthog }
